import { Button, Modal } from 'react-bootstrap';
import React, { ReactNode } from 'react';

interface Props {
    modal: boolean;
    setModal: (an: boolean) => any;
    dataBody: ReactNode;
    action: (data?: any) => void;
}

const ModalComponent: React.FunctionComponent<Props> = ({ modal, setModal, dataBody, action }: Props) => {
    return (
        <>
            <Modal show={modal} onHide={() => setModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>{dataBody}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={() => action()}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalComponent;
